import { message } from "antd";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/other/Loader";
import HeroSection from "../../layout/HeroSection";
import { pageRoutes } from "../../routes/pageRoutes";
import { useDispatch, useSelector } from "react-redux";
import NoRecord from "../../components/other/NoRecord";
import { curSym, pipGetAccessToken } from "../../utils/pip";
import { fetchEmbeds } from "../../redux/action/embedActions";
import { fetchCirriculumOverview, fetchSubscriptions } from "../../redux/action/moreAction";
const Curriculum = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const tabs = [
    {
      label: "Free",
      value: "free",
    },
    {
      label: "Monthly",
      value: "monthly",
    },
    {
      label: "Yearly",
      value: "yearly",
    },
  ];
  const [activeTab, setActiveTab] = useState(tabs[0]?.value);

  const { isLoading1, aboutData, subscriptionsList, curriculumOverview } = useSelector(
    (state) => state.moreReducer
  );

  useEffect(() => {
    dispatch(fetchEmbeds());
    dispatch(fetchSubscriptions());
    dispatch(fetchCirriculumOverview());
  }, []);

  const hanldeSubscription = () => {
    const token = pipGetAccessToken();

    if (token) {
      message.error("Students are not allowed to purchase subscriptions.");
    } else {
      navigate(pageRoutes?.login, {
        state: {
          data: activeTab,
        },
      });
    }
  };

  const filteredSubscriptions = subscriptionsList?.filter((plan) => {
    if (activeTab === "free") {
      return plan.is_paid === "No";
    }
    return plan.is_paid === "Yes";
  });


  if (isLoading1) {
    return <Loader />;
  }
  return (
    <div>
      <Header />
      <HeroSection
        label={<h1 class="mb-3">{"Curriculum"}</h1>}
        breadcrumbItems={[
          { name: "Home", path: `${pageRoutes?.home}` },
          {
            name: "Curriculum",
            path: `${pageRoutes?.home}`,
          },
        ]}
        banner_image={aboutData?.about_banner}
      />
      <section className="untree_co-section pt-5 pb-5 ">
        <div className="container">
          {/* <div class="row justify-content-between">
            <div class="col-lg-8 mx-auto text-center"></div>
            <div class="intro-excerpt">
              {curriculumOverview.title}
            </div>
          </div> */}

          {/* {curriculumOverview?.description && (
            <section style={{ background: "rgb(215 140 46 / 9%" }}>
              <div className="container py-5 ">
                <div className="row">
                  <div className="col-md-12">
                    <div
                      dangerouslySetInnerHTML={{ __html: curriculumOverview?.description }}
                    />
                  </div>
                </div>
              </div>
            </section>
          )} */}
          <div className="row justify-content-center mb-4">
            <div className="col-lg-8 text-center">
              <h2 className="fw-bold mb-3 ct_curriculum_title">
                {curriculumOverview?.title}
              </h2>
              <div className="ct_title_underline mx-auto"></div>
            </div>
          </div>
          {curriculumOverview?.description && (
            <section className="ct_curriculum_desc_section">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-9">
                    <div className="ct_curriculum_desc_card">
                      <div
                        className="ct_curriculum_desc"
                        dangerouslySetInnerHTML={{
                          __html: curriculumOverview?.description,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}

          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <ul class="nav nav-pills mb-3 ct_pricing_tabs ct_pricing_tabs mb-4">
                  {tabs?.map((item, index) => (
                    <li
                      key={index}
                      class="nav-item"
                      onClick={() => setActiveTab(item?.value)}
                      role="presentation"
                    >
                      <button
                        class={`nav-link ${activeTab == item?.value ? "active" : ""
                          }`}
                        type="button"
                      >
                        {item?.label}
                      </button>
                    </li>
                  ))}
                </ul>

                <div class="row">
                  {filteredSubscriptions?.length > 0 ? (
                    filteredSubscriptions?.map((item, index) => (
                      <div class="col-md-6 col-lg-3">
                        <div class="ct_pricing_card h-100">
                          <h4 class="ct_fs_16 ct_fw_600">
                            {item?.name || "#N/A"}
                          </h4>
                          <p class="text-muted">
                            For {item?.user_access_count > 1 && "up to"}{" "}
                            {item?.user_access_count || 0} user
                            {item?.user_access_count > 1 && "s"}
                          </p>
                          <h3 class="fw-bold ct_yellow_clr ">
                            {activeTab === tabs[0].value ? (
                              "Free"
                            ) : (
                              <>
                                {curSym} {item?.[activeTab + "_price"]}
                                <span className="fs-6">/{activeTab}</span>
                              </>
                            )}
                          </h3>
                          <ul class="list-unstyled">
                            <li>
                              <div>
                                <p>
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: item?.description || "",
                                    }}
                                  />
                                </p>
                              </div>
                            </li>
                          </ul>
                          <a
                            href="javascript:void(0)"
                            onClick={hanldeSubscription}
                            class="et_btn22 btn-secondary ct_btn_animate22 w-100 mt-3"
                          >
                            Buy Now
                          </a>
                        </div>
                      </div>
                    ))
                  ) : (
                    <NoRecord />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section >

      <Footer />
    </div >
  );
};

export default Curriculum;
